import { ReactNode, useEffect, useState } from "react";
import { cn } from "@/lib/utils";

interface StepTransitionProps {
  children: ReactNode;
  stepKey: number;
  direction?: "forward" | "backward";
}

export const StepTransition = ({ 
  children, 
  stepKey,
  direction = "forward" 
}: StepTransitionProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    // Reset animation on step change
    setIsVisible(false);
    setShouldRender(false);
    
    // Small delay to ensure DOM update
    const renderTimer = setTimeout(() => {
      setShouldRender(true);
    }, 10);

    // Trigger enter animation
    const enterTimer = setTimeout(() => {
      setIsVisible(true);
    }, 50);

    return () => {
      clearTimeout(renderTimer);
      clearTimeout(enterTimer);
    };
  }, [stepKey]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={cn(
        "transition-all duration-500 ease-out",
        isVisible 
          ? "opacity-100 translate-y-0" 
          : direction === "forward"
            ? "opacity-0 translate-y-4"
            : "opacity-0 -translate-y-4"
      )}
    >
      {children}
    </div>
  );
};
